<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import OurLocation from '$lib/PageSections/OurLocation/OurLocation.svelte';
</script>

<Section backgroundColor="white">
	<p>
		We understand and respect the need for customer privacy and data protection.
	</p>
	<p>
		When you give us permission, we may share your data internally and with our
		affiliated certified Indow dealers, or when required to do so by law. We
		never share, sell, or rent your data to any firm not directly related to
		your purchase or consideration of our products.
	</p>
	<p>
		Our website, email messages, and advertisements may use “cookies” and other
		technologies such as pixel tags. This helps us better understand which parts
		of our website people find useful.
	</p>
	<p>
		We use email automation for some stages of the order process. Our chat
		feature, phones and texts are all run by live Indow team members based in
		Portland, Oregon (and a couple others in the Midwest).
	</p>
	<p>
		Your Indow representative will refer competitors if we are not the best fit
		for your home. Fit Consultations over the phone or video chat will help them
		determine more quickly what is best for your windows.
	</p>
	<p>
		If you have any questions or concerns about our privacy policy or your
		personal data, please call us at <a href="tel:503-284-2260">503-284-2260</a
		>, or email
		<a href="mailto:comfort@indowwindows.com">comfort@indowwindows.com</a>.
	</p>
</Section>

<OurLocation />
